
const Controller = require('./controller');

let instance = null;

module.exports = function () {
	if (!instance) {
		instance = new Controller;
	}
	return instance;
};

